import { IconArrow, APPLY_ANCHOR } from './UEShared';

const UECtaSection = () => (
  <section id="cta">
    <div className="section-inner">
      <span className="section-label">
        <svg className="ico" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
        Ready to ride?
      </span>
      <h2>Your next job starts here.</h2>
      <p>
        Apply in a few minutes. Select{' '}
        <strong style={{ fontSize: '1.15em' }}>Amsterdam, Groningen and Rotterdam</strong> as your
        city and complete your application.
      </p>
      <a href={APPLY_ANCHOR} className="apply-btn">
        Apply now
        <IconArrow />
      </a>
      <div className="fine-print">
        <span>Amsterdam, Groningen and Rotterdam only</span>
        <span aria-hidden="true">·</span>
        <span>Own bike or scooter required</span>
        <span aria-hidden="true">·</span>
        <span>Flink employment contract</span>
      </div>
    </div>
  </section>
);

export default UECtaSection;
